import { AxiosInstance } from 'axios';
import { useAuthMutation } from 'features/common/apiUtils/queryHelper';
import { groupsApiConfig } from 'features/user-groups/api/config';
import { useQueryClient } from 'react-query';

const {
  add_delete_group_members: { url, scope },
  get_group_members: { queryKey },
} = groupsApiConfig;

export const useDeleteOrgGroupMembers = (groupId: string) => {
  const queryClient = useQueryClient();

  return useAuthMutation(
    (axiosInstance: AxiosInstance) => async (memberIds: string[]) => {
      await axiosInstance.delete(url(groupId), {
        data: { members: memberIds },
      });
    },
    {
      onSuccess: async () => {
        setTimeout(async () => {
          await queryClient.invalidateQueries([...queryKey, groupId]);
        }, 1000); // delay refetch for proper UI update
      },
    },
    scope,
  );
};
